import type { DailyBonusResponse, DailyQuestResponse, Wallet } from '@goodtime/shared';
import { api } from './client';

/** {@code GET /v1/players/{id}/wallet}: the server's wallet. */
export function fetchWallet(playerId: string): Promise<Wallet> {
  return api<Wallet>(`/players/${encodeURIComponent(playerId)}/wallet`);
}

/** {@code POST /v1/players/{id}/wallet/daily-bonus}: claim today's daily
 *  bonus on the server wallet. Safe to retry: a second claim inside 24 hours
 *  credits nothing and returns {@code claimed: false}. */
export function claimDailyBonus(playerId: string): Promise<DailyBonusResponse> {
  return api<DailyBonusResponse>(`/players/${encodeURIComponent(playerId)}/wallet/daily-bonus`, {
    method: 'POST',
  });
}

/** {@code POST /v1/players/{id}/wallet/daily-quest}: claim the world map's
 *  daily quest (coins + a gem) on the server wallet. Safe to retry: a second
 *  claim inside 24 hours credits nothing and returns {@code claimed: false}. */
export function claimDailyQuest(playerId: string): Promise<DailyQuestResponse> {
  return api<DailyQuestResponse>(`/players/${encodeURIComponent(playerId)}/wallet/daily-quest`, {
    method: 'POST',
  });
}
